import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';
import type ProfilEcritureFrequent from '../../../interfaces/pieces/mouvements/profilEcritureFrequent';

const baseUrl =
	'/api/finances/comptabilite/piecescomptables/profilEcritureFrequent';

export const getProfilsEcritureFrequent = (params: URLSearchParams) =>
	request.get<unknown, TemplateRequestGet<ProfilEcritureFrequent>>(
		`${baseUrl}?${params.toString()}`,
	);
